export default "__VITE_ASSET__jRCeBSzi__"